import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import FormatTime from 'src/components/FormatTime';

import { ROUTE_TYPES_VALUES } from 'src/modules/Restaurant';

import theme from 'src/styles/components/MenuCategoryHeader.module.scss';

const MenuCategoryHeader = ({ menuName, menuId, category, restaurantContext, style }) => {
    const intl = useIntl();

    return (
        <div
          className={classnames(theme.nameContainer, {
            [theme.notActive]: (!category.isActive
                && (
                    restaurantContext?.routeType === ROUTE_TYPES_VALUES.RESTAURANT
                    || restaurantContext?.routeType === ROUTE_TYPES_VALUES.BILL_STATUS
                    || restaurantContext?.routeType === ROUTE_TYPES_VALUES.BILL_WAIT
                    || (restaurantContext?.routeType === ROUTE_TYPES_VALUES.MENU
                        && restaurantContext?.isRestaurantOpen)))
          })}
          menuid={menuId}
          categoryid={category.id}
          style={style}
        >
            <div className={theme.categoryNameContainer}>
                <h2 className={theme.categoryName}>
                    {category.name}
                </h2>
                {!category.schedule.wholeDay && category.schedule.fromTime !== category.schedule.toTime && (
                <h2 className={theme.categoryTime}>
                    {category.schedule.fromTime && (
                    <>
                        {intl.formatMessage({ id: `App.from` })}
                        {' '}
                        <FormatTime time={category.schedule.fromTime} />
                    </>
                            )}
                    {category.schedule.toTime && (
                    <>
                        {' '}
                        {intl.formatMessage({ id: `App.to` })}
                        {' '}
                        <FormatTime time={category.schedule.toTime} />
                    </>
                            )}
                </h2>
                    )}
            </div>
            <div className={theme.menuNameContainer}>
                <h2 className={theme.menuName}>{menuName}</h2>
                {!category.isActive
                    && (
                        restaurantContext?.routeType === ROUTE_TYPES_VALUES.RESTAURANT
                        || restaurantContext?.routeType === ROUTE_TYPES_VALUES.BILL_STATUS
                        || restaurantContext?.routeType === ROUTE_TYPES_VALUES.BILL_WAIT
                        || (restaurantContext?.routeType === ROUTE_TYPES_VALUES.MENU
                            && restaurantContext?.isRestaurantOpen))
                    && (
                        <h2 className={theme.notAvailable}>
                            {intl.formatMessage({ id: `App.notAvailable` })}
                        </h2>
                    )}
            </div>
        </div>
    );
};

MenuCategoryHeader.propTypes = {
    restaurantContext: PropTypes.shape({
        tableId: PropTypes.string,
        restaurantId: PropTypes.string,
        routeType: PropTypes.number,
        isRestaurantOpen: PropTypes.bool
    }),
    category: PropTypes.shape({
        name: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        positions: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string.isRequired
        })),
        isActive: PropTypes.bool,
        schedule: PropTypes.object
    }),
    menuName: PropTypes.string,
    menuId: PropTypes.string,
    style: PropTypes.object
};

export default MenuCategoryHeader;
